import React from "react";
import { HeroSection } from "@/components/design-system/HeroSection/HeroSection";
import { URLS } from "@/data/constants";
import { trackCalendlyClick } from "@/utils/analytics";

export const CreditUnionHeroSection: React.FC = () => {
  const handleCalendlyClick = () => {
    trackCalendlyClick("cu_hero");
    window.open(URLS.CALENDLY, "_blank");
  };

  return (
    <HeroSection
      headline="Own the AI conversation your members are already having."
      description="Bravo brings AI-powered financial guidance back under your brand — where members receive personalized support they can trust."
      primaryCta={{ label: "Book a demo", onClick: handleCalendlyClick }}
      backgroundImage="/cu-hero.jpg"
      imageClassName="absolute top-0 right-0 h-full w-[65%] object-cover"
    />
  );
};
